<template>
  <layout-main>
    <div class="wrapper">
      <div v-if="announces.length === 0" class="no-announcement">
        <gl-sub-text>お知らせはありません</gl-sub-text>
      </div>
      <div v-else class="contents">
        <div
          v-for="announce in announces"
          :key="announce.id"
          class="announcement"
          :class="{ 'announcement--unread': announce.unread }"
        >
          <div class="announcement__title">
            {{ announce.issue_date }}
            {{ announce.title }}
          </div>
          <div class="announcement__body">
            <pre>{{ announce.body }}</pre>
          </div>
        </div>
      </div>
    </div>
  </layout-main>
</template>

<script>
import LayoutMain from '@/components/layout/LayoutMain'
import moment from 'moment'

export default {
  components: { LayoutMain },
  name: 'Announcement',
  data() {
    return {
      announces: [],
    }
  },
  async created() {
    await this.$service.getServices()
    const repo = this.$announcement
    const announces = (await repo.get()).map(
      ({ id, issueDate, title, body }) => ({
        id,
        issue_date: moment(issueDate).format('YYYY年M月D日'),
        title,
        body,
      }),
    )

    if (announces.length === 0) {
      return
    }

    this.lastRead = await repo.getLastRead()

    if (!this.lastRead) {
      this.announces = announces.map(a => ({
        ...a,
        unread: true,
      }))
    } else {
      const lastRead = this.lastRead
      this.announces = announces.map(a => ({
        ...a,
        unread: a.id > lastRead,
      }))
    }

    await repo.postLastRead(this.announces[0].id)
  },
}
</script>

<style lang='scss' scoped >
.wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: columns;
}

.contents {
  margin-top: var(--spacing-large);
  margin-bottom: var(--spacing-large);
  width: 80%;
  min-width: 400px;
  max-width: 800px;
}

.announcement {
  &:not(:first-child) {
    margin-top: var(--spacing-medium);
  }
}

.announcement {
  padding: var(--spacing-medium);
  border-radius: 5px;
  border: 1px solid var(--color-border);
  box-sizing: content-box;

  &--unread {
    background: #ffebee;
    border: 0;
  }

  &__title {
    color: var(--color-secondary-text);
    font-size: var(--font-size-normal);
  }

  &__body {
    font-size: var(--font-size-normal);

    pre {
      white-space: pre-wrap;
    }
  }
}

.no-announcement {
  text-align: center;
  margin-top: var(--spacing-large);
}
</style>
